window.Roblox.BuildPage = window.Roblox.BuildPage || {};

window.Roblox.BuildPage.UploadFeeHandler = (function () {
  const groupIframeSelector = '.group-upload-iframe';
  const confirmTransaction = 'confirmTransaction';
  const declineTransaction = 'declineTransaction';
  const insufficientFundsForTransaction = 'insufficientFunds';
  const selfIframeSelector = '.my-upload-iframe';
  const tShirtID = 2;
  const shirtID = 11;
  const pantsID = 12;

  function getAssetNameForAssetType(typeId) {
    switch (typeId) {
      case tShirtID:
        return 'TShirt';
      case shirtID:
        return 'Shirt';
      case pantsID:
        return 'Pants';
    }
  }

  function sendMessage(data, isSuccessful) {
    // this posts back to iframe
    const toSend = { ...data, success: isSuccessful };
    if (data.isGroupUpload) {
      $(groupIframeSelector)[0].contentWindow.postMessage(toSend, "*");
    }
    else {
      $(selfIframeSelector)[0].contentWindow.postMessage(toSend, '*');
    }
  }

  function handleMessage() {
    window.addEventListener('message', function (event) {
      if (event.origin === window.location.origin && event.data.method === confirmTransaction) {
        openUploadFeeConfirmationDialogue(event);
      }
    });
  }

  function openUploadFeeConfirmationDialogue(event) {
    Roblox.Dialog.open({
      titleText: 'Upload Item',
      bodyContent: `Would you like to upload your ${getAssetNameForAssetType(
        event.data.assetType
      )} for ${event.data.price} Robux?`,
      xToCancel: false,
      acceptText: 'Confirm',
      declineText: 'Cancel',
      acceptColor: Roblox.Dialog.green,
      onAccept() {
        event.data.method = confirmTransaction;
        sendMessage(event.data, true);
      },
      onDecline() {
        event.data.method = declineTransaction;
        sendMessage(event.data, true);
      },
      allowHtmlContentInBody: true
    });
  }

  return {
    handleMessage
  };
})();

$(function () {
  window.Roblox.BuildPage.UploadFeeHandler.handleMessage();
});